import { IsDefined, IsInt, IsOptional } from 'class-validator';
import { Exclude } from 'class-transformer';

export class AclStockPermissionCreateDto {
  @IsDefined()
  @IsInt()
  sourceMerchantId: number;

  @IsDefined()
  @IsInt()
  targetMerchantId: number;

  @IsDefined()
  @IsInt()
  stockEntityId: number;

  @IsDefined()
  @IsInt()
  supplierEntityId: number;

  @IsDefined()
  @IsInt()
  stockPermissionListId: number;
}
